import React, { Component } from 'react';
import './index.css';

export default class Footer extends Component {
	render(){
		return (
			<div className="footer">
                <div className="copyright">© Nan Chen 2021</div>
			</div>
		  );
	}
};
